import { Box, Container, Grid, Link, List, ListItem, Typography } from '@mui/material';
import Logo from '../../ui/Logo/Logo';
import { PAGE } from '../../../constants/page';
import NavButton from '../../ui/NavBUtton/NavButton';

interface Props {
  children?: React.ReactElement<unknown>;
}

const footerLinks: Array<{ text: string, subText: string, url: string }> = [
  { text: PAGE.TOP.NAME, subText: PAGE.TOP.TEXT, url: PAGE.TOP.PATH },
  { text: PAGE.SERVICE.NAME, subText: PAGE.SERVICE.TEXT, url: PAGE.SERVICE.PATH },
  { text: PAGE.NEWS.NAME, subText: PAGE.NEWS.TEXT, url: PAGE.NEWS.PATH },
  { text: PAGE.RECRUIT.NAME, subText: PAGE.RECRUIT.TEXT, url: PAGE.RECRUIT.PATH },
  { text: PAGE.COMPANY.NAME, subText: PAGE.COMPANY.TEXT, url: PAGE.COMPANY.PATH },
  { text: PAGE.CONTACT.NAME, subText: PAGE.CONTACT.TEXT, url: PAGE.CONTACT.PATH },
];

const helpLinks: Array<{ text: string, url: string }> = [
  { text: PAGE.SECURITY.TEXT, url: PAGE.SECURITY.PATH },
]

export default function Footer(props: Props) {
  return (
    <Box component={'footer'} sx={(theme) => ({
      backgroundColor: theme.palette.grey[900],
      color: theme.palette.grey[50],
      textAlign: 'center',
      padding: '5rem 1rem'
    })}>
      <Container>
        <Grid container>
          <Grid size={12}>
            <List sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', width: 'auto', marginBottom: '1rem' }}>
              {footerLinks.map((footerLink, index) => (
                <ListItem key={index} disablePadding sx={{ margin: '1rem', width: 'auto' }}>
                  <NavButton
                    color='dark'
                    activeDisabled
                    href={footerLink.url}
                    text={footerLink.text}
                    subText={footerLink.subText}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid size={12}>
            <List sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', width: 'auto', marginBottom: '1rem' }}>
              {helpLinks.map((helpLink, index) => (
                <ListItem key={index} disablePadding sx={{ margin: '1rem', width: 'auto' }}>
                  <Link underline="hover" color="inherit" href={helpLink.url}>
                    {helpLink.text}
                  </Link>
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid size={12}>
            <Logo color='dark' />
          </Grid>
          <Grid size={12}>
            <Typography>
              Copyright © Suprime Co., Ltd. All Rights Reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box >
  );
}